import { useMemo } from 'react';
import { ClaimResponse as Claim } from '@sentara-health/sentara-api-hooks-core';

import { ClaimsIndex } from '../utils/ClaimsIndex';
import {
  queryClaims,
  ClaimsQuery,
  SortField,
  SortOrder,
} from '../utils/ClaimsQuery';
import { ClaimsFilterState } from '../types/claimsFilters';

export interface ClaimsQueryResult {
  claims: Claim[];
  totalCount: number;
}

export interface UseClaimsQueryParams {
  index: ClaimsIndex;
  sortBy?: SortField;
  sortOrder?: SortOrder;
  filters?: ClaimsFilterState;
}

export function useClaimsQuery({
  index,
  sortBy = 'dateOfService',
  sortOrder,
  filters,
}: UseClaimsQueryParams): ClaimsQueryResult {
  const query: ClaimsQuery = useMemo(
    () => ({ sortBy, sortOrder, filters }),
    [sortBy, sortOrder, filters]
  );

  const claims: Claim[] = useMemo(
    () => queryClaims(index, query),
    [index, query]
  );

  return {
    claims,
    totalCount: claims.length,
  };
}
